export default __webpack_public_path__ + "static/media/AMBIANCE ELEMENTS_1.8647ada3.wav";